module.exports = __webpack_public_path__ + "static/signature-packaging-cat-f471dd9868d99ee02c82b2cb213d370a.jpg";